import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import GemSellCallout from "@/components/GemSellCallout";
import { api } from "@/lib/api";
import { isGemExchangeStore } from "@/lib/gems";
import { formatGBP } from "@/lib/utils-cart";

export default function Storefront() {
  const { slug } = useParams();
  const [store, setStore] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    let live = true;
    setStore(null);
    setMissing(false);
    api.get(`/stores/by-slug/${slug}`)
      .then((r) => { if (live) setStore(r.data); })
      .catch(() => { if (live) setMissing(true); });
    return () => { live = false; };
  }, [slug]);

  if (missing) {
    return (
      <PublicLayout>
        <div className="px-4 py-20 text-center" data-testid="storefront-missing">
          <p className="text-lg font-semibold text-primary">Store not found</p>
          <Link to="/stores" className="v-btn-outline mt-6" data-testid="storefront-back">Back to Stores</Link>
        </div>
      </PublicLayout>
    );
  }
  if (!store) return <PublicLayout><div className="p-20 text-center text-muted-foreground">Loading store…</div></PublicLayout>;

  const gemStore = isGemExchangeStore(store);

  return (
    <PublicLayout>
      <section
        className="relative bg-primary text-primary-foreground"
        style={{ backgroundColor: store.primary_color }}
      >
        <div className="absolute inset-0 grid-bg opacity-10" />
        <div className="relative max-w-7xl mx-auto px-6 py-16 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="label-eyebrow" style={{ color: store.accent_color }}>{(store.business_type || "").replace("_", " ")}</div>
            <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter leading-none mt-3">{store.name}</h1>
            {!gemStore && store.description && <p className="mt-4 text-white/80 max-w-md">{store.description}</p>}
          </div>
          <div className="rounded-sm overflow-hidden border border-white/15">
            <img src={store.banner_url} alt={store.name} className="w-full h-72 object-cover" />
          </div>
        </div>
      </section>

      {gemStore ? (
        <GemSellCallout store={store} />
      ) : (
        <section className="max-w-7xl mx-auto px-6 py-12">
          <h2 className="font-display text-2xl font-bold text-primary">Featured products</h2>
          <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {store.products?.map((p) => (
              <Link key={p.id} to={`/product/${p.id}`} className="v-card p-3 flex flex-col group" data-testid={`storefront-product-${p.id}`}>
                <div className="aspect-square bg-muted overflow-hidden">
                  <img src={p.images?.[0]} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
                </div>
                <div className="pt-3 flex-1 flex flex-col">
                  <h3 className="text-sm font-semibold text-primary line-clamp-2">{p.title}</h3>
                  <div className="mt-auto pt-2 font-display font-bold text-lg">{formatGBP(p.price)}</div>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )}
    </PublicLayout>
  );
}
